import BaseApi from '@/api/Base/BaseApi'
import { GetUserAndWorkspaceResponse, HealthCheckResponse } from '@/api/OnPremise/types'

const ROOT = '/on-premise'

export default class OnPremiseApi extends BaseApi {
  healthCheck() {
    return this.agent.get<HealthCheckResponse>(`${ROOT}/health-check`)
  }

  getUserAndWorkspace() {
    return this.agent.get<GetUserAndWorkspaceResponse>(`${ROOT}/user`)
  }

  cancelAllTasks() {
    return this.agent.post(`${ROOT}/cancel-all-tasks`)
  }

  // TODO: query key 만들지 말지 고민 필요
  getDiskUsageInfo() {
    return this.agent.get<any>(`${ROOT}/disk-usage-info`)
  }
}
